var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnDownloadBlue = function SvgIcnDownloadBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.48 6H9V3a1 1 0 0 0-2 0v3H4.52a.25.25 0 0 0-.195.406l3.48 4.35c.1.125.29.125.39 0l3.48-4.35A.25.25 0 0 0 11.48 6ZM4 12a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H4Z",
    fill: "#13ADC7"
  })));
};

export { SvgIcnDownloadBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS40Nzk4IDZIOC45OTk5OUw5IDNDOSAyLjQ0NzcyIDguNTUyMjggMiA4IDJDNy40NDc3MSAyIDcgMi40NDc3MSA3IDNMNi45OTk5OSA2SDQuNTIwMTVDNC4zMTA1MyA2IDQuMTkzOTggNi4yNDI0OCA0LjMyNDk0IDYuNDA2MTdMNy44MDQ3OCAxMC43NTZDNy45MDQ4NiAxMC44ODExIDguMDk1MTMgMTAuODgxMSA4LjE5NTIxIDEwLjc1NkwxMS42NzUxIDYuNDA2MTdDMTEuODA2IDYuMjQyNDggMTEuNjg5NSA2IDExLjQ3OTggNlpNNCAxMkMzLjQ0NzcyIDEyIDMgMTIuNDQ3NyAzIDEzQzMgMTMuNTUyMyAzLjQ0NzcyIDE0IDQgMTRIMTJDMTIuNTUyMyAxNCAxMyAxMy41NTIzIDEzIDEzQzEzIDEyLjQ0NzcgMTIuNTUyMyAxMiAxMiAxMkg0WiIgZmlsbD0iIzEzQURDNyIvPgo8L3N2Zz4K";